import useClientGlobalSettings from './client-global-settings-hook';

const useReferAFriendEnabled = () => {
  const settingsQuery = useClientGlobalSettings();

  return settingsQuery.data?.referAFriendEnabled === true;
};

export default useReferAFriendEnabled;
